import { APP_PAGE_URL } from "utils/env-management"

export function GiftCertificateBanner() {
    return (
        <a
            href={`${APP_PAGE_URL}/gift`}
            target="_blank"
            rel="noopener noreferrer"
            className="after-payment__gift-certificate"
        >
            <div>
                <div className="after-payment__gift-certificate__text">
                    Подарите близким сертификат на&nbsp;психотерапию от&nbsp;5000&nbsp;₽
                </div>
                <div className="b2b-banner__link after-payment__gift-certificate-link">
                    Подарить
                </div>
            </div>
        </a>
    )
}
